// Service Functions to Create / Load / Update / Delete Cortex Records
// This file contains all of the business logic for dealing with Release Notes
import axiosInstances from '@/../../coreui/server/axiosInstances'
import check from "@/../../library/helper/propertyCheck.js"
const CONSTANTS = require("@/../../library/constants/server.js")

// Create a record
export async function create(table, payload, server = null) {
    console.log(`Create Function`)
    console.log(`TABLE: `, table)
    console.log(`PAYLOAD: `, payload)
    let target = `/dt/v1/${table}`
    let result = null
    if (!check.isNull(server) && server === CONSTANTS.LOGIN)
        result = await axiosInstances.loginServer.post(target, payload)
    else if (!check.isNull(server) && server === CONSTANTS.ORIG)
        result = await axiosInstances.origApiServer.post(target, payload)
    else
        result = await axiosInstances.apiServer.post(target, payload)
    return result.data
}

// Load a record
export async function load(table, id, server = null) {
    console.log(`Load Note Function`)
    let target = `/dt/v1/${table}/${id}`
    let result = null
    if (!check.isNull(server) && server === CONSTANTS.LOGIN)
        result = await axiosInstances.loginServer.get(target)
    else if (!check.isNull(server) && server === CONSTANTS.ORIG)
        result = await axiosInstances.origApiServer.get(target)
    else
        result = await axiosInstances.apiServer.get(target)
    return result.data
}

// Load First Active Record
export async function loadOneActive(table, server = null){
    let target = `/dt/v1/${table}?IsUsed=yes&last=1`
    let result = null
    if (!check.isNull(server) && server === CONSTANTS.LOGIN)
        result = await axiosInstances.loginServer.get(target)
    else if (!check.isNull(server) && server === CONSTANTS.ORIG)
        result = await axiosInstances.origApiServer.get(target)
    else
        result = await axiosInstances.apiServer.get(target)
    //console.log(`Load Active Result = `, result.data)
    return result.data[0]
}

// Find First Record matching a criteria
export async function findOne(conditions, table, server = null){
    let target = `/misc/dbops?c=${table}&op=pipe`
    let result = null
    if (!check.isNull(server) && server === CONSTANTS.LOGIN)
        result = await axiosInstances.loginServer.post(target, conditions)
    else if (!check.isNull(server) && server === CONSTANTS.ORIG)
        result = await axiosInstances.origApiServer.post(target, conditions)
    else
        result = await axiosInstances.apiServer.post(target, conditions)
    console.log(`Load Active Result = `, result.data)
    let resultArray = result.data
    console.log(`FIND ONE Result `, result.data)
    if(check.isNull(resultArray) || check.isEmptyArray(resultArray)) return null
    return resultArray[0]
}

// Load a table
export async function loadTable(table, server = null) {
    let target = `/dt/v1/${table}`
    let result = null
    if (!check.isNull(server) && server === CONSTANTS.LOGIN)
        result = await axiosInstances.loginServer.get(target)
    else if (!check.isNull(server) && server === CONSTANTS.ORIG)
        result = await axiosInstances.origApiServer.get(target)
    else
        result = await axiosInstances.apiServer.get(target)
    return result.data
}

// Update a record
export async function update(table, record, server = null) {
    let target = `/dt/v1/${table}/${record["_id"]}`
    let result = null
    if (!check.isNull(server) && server === CONSTANTS.LOGIN)
        result = await axiosInstances.loginServer.patch(target, record)
    else if (!check.isNull(server) && server === CONSTANTS.ORIG)
        result = await axiosInstances.origApiServer.patch(target, record)
    else
        result = await axiosInstances.apiServer.patch(target, record)
}